export const ORDER_HISTORY_FILTERS = {
    ALL: 'ALL',
    DRAFT: 'DRAFT',
    COMPLETED: 'COMPLETED',
    ACCEPTED: 'ACCEPTED',
    PAYMENT_REMAINED: 'PAYMENT_REMAINED',
    TO_BE_ASSESSED: 'TO_BE_ASSESSED',
    REJECTED: 'REJECTED'
}

export const MAPPED_ORDER_HISTORY_STATUS = {
    TO_BE_ASSESSED: 'To Be Assessed',
    DRAFT: 'Draft',
    COMPLETED: 'Completed',
    ACCEPTED: 'Accepted',
    PAYMENT_REMAINED: 'Payment Remained',
    REJECTED: 'Rejected'
}

export const REVERSE_MAP_ORDER_HISTORY_STATUS_FOR_ADMIN = {
  'To Be Assessed': 'TO_BE_ASSESSED',
  'Accepted': 'ACCEPTED',
  'Completed': 'COMPLETED',
  'Rejected': 'REJECTED'
}

export const TYPE_SELECTION = {
    OVER_THE_COUNTER: 'Over-The-Counter',
    PRESCRIBED_MEDICATION: 'Prescribed Medication',
    VAPING: 'Vaping | e-Cigarettes',
    COMBINATION_THERAPY: 'Combination Therapy'
}

export const DRUG_SELECTION = {
    nicovape: 'Nicovape',
    BUPROPION: 'Bupropion (Zyban)',
    VARENICLINE: 'Varenicline (Champix)'
}

export const REGULATION_24_DRUG_SELECTED = ["bupropion", "varenicline", "sildenafil", "tadalafil", "avanafil", "vardenafil", "levitra", "spedra", "nicovape", "allo sync", "veev", "wild by instinct"];

export const INSTANT_HUSH_SPECIAL_DRUGS_FILLED = ["sildenafil", "tadalafil", "avanafil", "vardenafil", "levitra", "spedra"];


export const ONLINE_ASSESSMENT_TYPES = ["ERECTILE_DYSFUNCTION", "PREMATURE_EJACULATION", "SLEEP_LOSS", "HAIR_LOSS"];

export const ONLINE_ASSESSMENT_TYPES_OBJ = {
    'ERECTILE_DYSFUNCTION': 'Erectile Dysfunction',
    'PREMATURE_EJACULATION': 'Premature Ejaculation',
    'SLEEP': 'Sleep Loss',
    'HAIR_LOSS': 'Hair Loss'
};

export const MAPPED_ONLINE_ASSESSMENT_TYPES_OBJ = {
    'Erectile Dysfunction': 'ERECTILE_DYSFUNCTION',
    'Premature Ejaculation': 'PREMATURE_EJACULATION',
    'Sleep Loss': 'SLEEP_LOSS',
    'Hair Loss': 'HAIR_LOSS'
}

export const STATE_LIST = [{ "_id": "592682341c8804c0f68805e9", "stateId": "ACT", "stateName": "Australian Capital Territory" }, { "_id": "58b675ca088ded0a4193954a", "stateId": "NSW", "stateName": "New South Wales" }, { "_id": "58b675ca088ded0a4193954e", "stateId": "NT", "stateName": "Northern Territory" }, { "_id": "58b675ca088ded0a41939549", "stateId": "QLD", "stateName": "Queensland" }, { "_id": "58b675ca088ded0a4193954d", "stateId": "SA", "stateName": "South Australia" }, { "_id": "58b675ca088ded0a4193954f", "stateId": "TAS", "stateName": "Tasmania" }, { "_id": "58b675ca088ded0a4193954b", "stateId": "VIC", "stateName": "Victoria" }, { "_id": "58b675ca088ded0a4193954c", "stateId": "WA", "stateName": "Western Australia" }];
export const STATE_LIST_SHORT = [
    { "_id": "592682341c8804c0f68805e9", "stateId": "ACT", "stateName": "ACT" },
    { "_id": "58b675ca088ded0a4193954a", "stateId": "NSW", "stateName": "NSW" },
    { "_id": "58b675ca088ded0a4193954e", "stateId": "NT", "stateName": "NT" },
    { "_id": "58b675ca088ded0a41939549", "stateId": "QLD", "stateName": "QLD" },
    { "_id": "58b675ca088ded0a4193954d", "stateId": "SA", "stateName": "SA" },
    { "_id": "58b675ca088ded0a4193954f", "stateId": "TAS", "stateName": "TAS" },
    { "_id": "58b675ca088ded0a4193954b", "stateId": "VIC", "stateName": "VIC" },
    { "_id": "58b675ca088ded0a4193954c", "stateId": "WA", "stateName": "WA" }];

export const CATEGORY_FOR_MEDICINAL_CANNABIS = [
    {
        _id: '1',
        value: 'Category 1',
    },
    {
        _id: '2',
        value: 'Category 2',
    },
    {
        _id: '3',
        value: 'Category 3',
    },
    {
        _id: '4',
        value: 'Category 4',
    },
    {
        _id: '5',
        value: 'Category 5',
    }
];

export const MEDICINAL_CANNABIS_INDICATIONS = [
    {
        _id: '1',
        value: 'Treatment of refractory chronic pain in adult patients,\nTreatment of refractory anxiety in adult patients',
    },
    {
        _id: '2',
        value: 'Treatment of refractory chronic pain in adult patients,\nTreatment of refractory anxiety in adult patients',
    },
    {
        _id: '3',
        value: 'Treatment of refractory chronic pain in adult patients',
    }];

export function getIndicationText(id) {
    for (const indication of MEDICINAL_CANNABIS_INDICATIONS) {
        if (indication._id === id) {
            return indication.value;
        }
    }
    return '';
}

export const INCENTIVE_DEFAULT_ITEMS = [
    // {
    //   itemNo: 10981,
    //   description: "Patient is at risk of COVID-19",
    //   description1: "10981 Patient is at risk of COVID-19 $12.95",
    //   price: 12.95
    // },
    {
        _id: 0,
        itemNo: 10990,
        description: "Patient is under 16",
        // description1: "10990 Patient is under 16 $12.95",
        description1: "10990 Patient is under 16 $7.35",
        val: "10990 Patient is under 16 $7.35", // for select input
        // price: 6.90,
        // price: 7.15
        price: 7.35
    },
    {
        _id: 1,
        itemNo: 10990,
        description: "Patient is a Concession Card Holder",
        // description1: "10990 Patient is a Concession Card Holder $12.95",
        description1: "10990 Patient is a Concession Card Holder $7.35",
        val: "10990 Patient is a Concession Card Holder $7.35", // for select input
        // price: 6.90,
        price: 7.35
    }
];

export const INCENTIVE_DEFAULT_ITEMS_91800 = [
    // {
    //   itemNo: 10981,
    //   description: "Patient is at risk of COVID-19",
    //   description1: "10981 Patient is at risk of COVID-19 $12.95",
    //   price: 12.95
    // },
    {
        _id: 0,
        itemNo: 75870,
        description: "Patient is under 16",
        // description1: "75870 Patient is under 16 $12.95",
        description1: "75870 Patient is under 16 $21.85",
        val: "75870 Patient is under 16 $21.85", // for select input
        price: 21.85
    },
    {
        _id: 1,
        itemNo: 75870,
        description: "Patient is a Concession Card Holder",
        // description1: "75870 Patient is a Concession Card Holder $12.95",
        description1: "75870 Patient is a Concession Card Holder $21.85",
        val: "75870 Patient is a Concession Card Holder $21.85", // for select input
        price: 21.85
    }
];

export const IS_ASSESSMENT_TYPES = {
    SMOKING_CESSATION: "Smoking Cessation",
    MEDICINAL_CANNABIS: "Medicinal Cannabis",
};

export const cpdMOTags = [
    "Allergy/Hay Fever (Acute Care)",
    "Arthritis: Gout",
    "Arthritis: Osteoarthritis",
    "Arthritis: Rheumatoid Arthritis",
    "Asthma",
    "Attention-Deficit/Hyperactivity Disorder (ADHD)",
    "Back Pain",
    "Cardiovascular Disease (CVD)",
    "Chronic Kidney Disease (CKD)",
    "Chronic Obstructive Pulmonary Disease (COPD)",
    "Chronic Pain",
    "Coeliac Disease",
    "Constipation/Diarrhoea (Acute Care)",
    "Contraception",
    "Cough/Cold/Flu/Respiratory Tract Infection (RTI) (Acute Care)",
    "Diabetes",
    "Endometriosis",
    "Erectile Dysfunction (ED)",
    "Fatty Liver",
    "Fertility",
    "Gastro-Oesophageal Reflux Disease (GORD)",
    "Hair Loss",
    "Headaches/Migraines (Acute Care)",
    "Hyperlipidaemia/High Cholesterol (LDL)",
    "Hypertension/High Blood Pressure (HBP)",
    "Incontinence",
    "Indigestion (Acute Care)",
    "Irritable Bowel Syndrome (IBS)",
    "Menopause/Perimenopause",
    "Menorrhagia/Dysmenorrhea",
    "Mental Health: Anxiety/Depression",
    "Mental Health: Eating Disorders",
    "Mental Health: Post-Traumatic Stress Disorder (PTSD)",
    "Mental Health: Substance Use/Addiction (Alcohol, Drugs)",
    "Musculoskeletal Injuries (Acute Care)",
    "Paediatric",
    "Polycystic Ovary Syndrome (PCOS)",
    "Premature Ejaculation (PE)",
    "Pregnancy: Attempting Conception",
    "Pregnancy: Morning Sickness",
    "Pregnancy: Pregnant",
    "Sexual Health",
    "Shingles (VZV)",
    "Skin: Acne",
    "Skin: Dermatitis/Eczema",
    "Skin: Skin Infections",
    "Sleep Disorder: Insomnia",
    "Sleep Disorder: Obstructive Sleep Apnoea (OSA)",
    "Sleep Disorder: Other",
    "Smoker",
    "Urinary Tract Infection (UTI)",
    "Vertigo",
    "Weight Loss/Weight Management"
];  
